module.exports = __webpack_public_path__ + "static/media/trash.cacd6666.svg";